import React from 'react';

const BASE = process.env.PUBLIC_URL || '';
const HERO_GIF = `${BASE}/static/css/assets/img/260205_ADX_Hub_Animation_TRANSPARENT_TSI.gif`;
const HERO_LOGO = `${BASE}/static/css/assets/img/adx2-logo.png`;
const HERO_LAYER = `${BASE}/static/css/assets/img/ADX_Hub_Header_Keyvisual_Layer_transparent.png`;

export default function HeroKeyvisual() {
  return (
    <div className="relative h-full w-full overflow-hidden bg-[#0028CD]">
      <div className="pointer-events-none absolute inset-0">
        <div
          className="absolute inset-0 opacity-[0.3]"
          style={{
            backgroundImage: 'radial-gradient(rgba(255,255,255,0.14) 1px, transparent 1px)',
            backgroundSize: '20px 20px',
          }}
        />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-8%,rgba(255,255,255,0.12),transparent_34%),radial-gradient(circle_at_50%_20%,rgba(0,0,0,0.16),transparent_30%)]" />
        <img
          src={HERO_LAYER}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-contain object-top opacity-[0.24]"
          draggable="false"
        />
      </div>

      <div className="absolute inset-0 p-3 sm:p-4 md:p-5 lg:p-6">
        <img
          src={HERO_GIF}
          alt="Asset Data eXchange Hub animation"
          className="h-full w-full object-contain object-center select-none"
          style={{ transform: 'scale(1.12)' }}
          draggable="false"
        />
      </div>
      <div
        className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center"
        style={{ transform: 'translateX(-6.5%)' }}
      >
        <img
          src={HERO_LOGO}
          alt="ADX Hub"
          className="h-auto max-h-[72%] w-auto object-contain select-none"
          style={{
            width: 'clamp(7.25rem, 16vw, 12.5rem)',
            filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.14))',
          }}
          draggable="false"
        />
      </div>
    </div>
  );
}
